export default {
  root: {
    flexDirection: 'column',
    maxHeight: 250,
    overflow: 'auto',
  },
};
